import { stage01 } from './stage01';
import { stage02 } from './stage02';
import { stage03 } from './stage03';
import { StageData } from '../../game/StageLoader';

export const ALL_STAGES: StageData[] = [stage01, stage02, stage03];
